<script>
import RepairFileService from '@/services/RepairFileService'
import TransportModalityConstant from '@/constants/transportModalityConstant'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import manufacturerService from '@/services/referentiel/ManufacturerService'
import {
  convertDateFromInput,
  displayToast,
  shouldShowTooltip,
  handleResponseError
} from '@/components/utils/globalFunction'
import RepairFileStatusMacroConstant from '@/constants/repairFileStatusMacroConstant'
import ExportService from '@/services/ExportService'
import router from '@/router'

export default {
  name: 'RepairFileList',
  data() {
    return {
      loading: false,
      isClearingFilters: false,
      search: '',
      sort: 'business_created_day_count',
      order: 'desc',
      isOrderNeutral: true,
      page: 1,
      maxPage: null,
      limit: 25,
      loadingMore: false,
      intersectionObserver: null,
      headers: [
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.REPAIR_FILE_BOOMERANG_ID'),
          value: 'internal_command_number',
          width: '125px'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.STORE_NAME'),
          value: 'store_name'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.COMPANY_NAME'),
          value: 'company'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.MANUFACTURER_NAME'),
          value: 'manufacturer_name'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.PRODUCT_NAME'),
          value: 'product_name'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.RENTAL'),
          value: 'has_rental_file'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.STATUS'),
          value: 'status_macro'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.TIME'),
          value: 'business_created_day_count',
          sortable: true,
          width: '120px'
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.DATE'),
          value: 'business_created_at',
          sortable: true
        },
        {
          title: this.$t('REPAIR_FILE_LIST_PAGE.TABLE.MODALITY'),
          value: 'transporter_modality'
        }
      ],
      repairFileList: [],

      needAction: false,
      fileStatus: false,
      fileWithRental: false,
      showFilter: false,
      filters: { status: false, need_action: false },

      manufacturerList: [],
      selectedManufacturer: null,
      deleteFiltersButton: false,

      statusMacroList: Object.keys(RepairFileStatusMacroConstant)
        .filter(
          (key) =>
            RepairFileStatusMacroConstant[key] !== 'DRAFT' &&
            RepairFileStatusMacroConstant[key] !== 'DELETED'
        )
        .map((key) => ({
          title: this.$t('COMMON.STATUS_MACRO.' + RepairFileStatusMacroConstant[key]),
          value: RepairFileStatusMacroConstant[key]
        })),
      selectedStatusMacro: null,

      transportModalityList: Object.keys(TransportModalityConstant).map((key) => ({
        title: this.$t('REPAIR_FILE_LIST_PAGE.MODALITY.' + TransportModalityConstant[key]),
        value: TransportModalityConstant[key]
      })),
      selectedTransportModality: null,

      storeList: [],
      selectedStore: null,

      selectedDates: null,
      today: new Date()
    }
  },
  async created() {
    this.search = this.$route.query.search || ''
    await this.getRepairFileFullList()
    await this.getManufacturerList()
    await this.getStoreList()
  },
  mounted() {
    this.setupInfiniteScroll()
  },
  beforeUnmount() {
    this.cleanupInfiniteScroll()
  },
  watch: {
    async selectedDates(newValues) {
      if (this.isClearingFilters) return

      if (newValues !== null) {
        const startDate = convertDateFromInput(newValues[0])
        const lastDate = convertDateFromInput(newValues[newValues.length - 1])
        this.filters = { ...this.filters, time_min: startDate, time_max: lastDate }
      } else {
        this.filters = { ...this.filters, time_min: null, time_max: null }
      }

      this.page = 1
      await this.getRepairFileFullList()
    },
    async needAction() {
      if (this.isClearingFilters) return

      this.filters = { ...this.filters, need_action: this.needAction }
      this.page = 1
      await this.getRepairFileFullList()
    },
    async fileStatus() {
      if (this.isClearingFilters) return

      this.filters = { ...this.filters, status: this.fileStatus }
      this.page = 1
      await this.getRepairFileFullList()
    },
    async fileWithRental() {
      if (this.isClearingFilters) return

      this.filters = { ...this.filters, rental: this.fileWithRental }
      this.page = 1
      await this.getRepairFileFullList()
    },
    async selectedManufacturer() {
      if (this.isClearingFilters) return

      if (this.selectedManufacturer) {
        this.filters = { ...this.filters, manufacturer: this.selectedManufacturer }
      } else {
        delete this.filters.manufacturer
      }
      this.page = 1
      await this.getRepairFileFullList()
    },
    async selectedStatusMacro() {
      if (this.isClearingFilters) return

      if (this.selectedStatusMacro) {
        this.filters = { ...this.filters, status_macro: this.selectedStatusMacro }
      } else {
        delete this.filters.status_macro
      }
      this.page = 1
      await this.getRepairFileFullList()
    },
    async selectedTransportModality() {
      if (this.isClearingFilters) return

      if (this.selectedTransportModality) {
        this.filters = { ...this.filters, modality: this.selectedTransportModality }
      } else {
        delete this.filters.modality
      }
      this.page = 1
      await this.getRepairFileFullList()
    },
    async selectedStore() {
      if (this.isClearingFilters) return

      if (this.selectedStore) {
        this.filters = { ...this.filters, store: this.selectedStore }
      } else {
        delete this.filters.store
      }
      this.page = 1
      await this.getRepairFileFullList()
    },
    repairFileList() {
      this.cleanupInfiniteScroll()
      this.setupInfiniteScroll()
    },
    async isClearingFilters() {
      this.page = 1
      await this.getRepairFileFullList()
    }
  },
  computed: {
    ascSortIcon() {
      return this.isOrderNeutral ? 'mdi-chevron-right' : 'mdi-chevron-up'
    },
    descSortIcon() {
      return this.isOrderNeutral ? 'mdi-chevron-right' : 'mdi-chevron-down'
    }
  },
  methods: {
    shouldShowTooltip,
    checkPermission(permissionsRequired) {
      return this.$store.getters['auth/hasPermission'](permissionsRequired)
    },
    async sendSearch() {
      this.page = 1
      await this.getRepairFileFullList()
    },
    async getRepairFileFullList() {
      this.loading = true
      try {
        const response = await RepairFileService.getPaginatedRepairFileFullList(
          this.search,
          this.sort,
          this.order,
          this.page,
          this.limit,
          this.filters
        )
        this.repairFileList = response.data
        this.maxPage = response.max_page
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.checkIfFiltersSelected()
        this.loading = false
      }
    },
    async getManufacturerList() {
      try {
        this.loading = true
        const response = await manufacturerService.getManufacturerList()
        this.manufacturerList = response.itemList
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getStoreList() {
      try {
        this.loading = true
        this.storeList = this.$store.getters['auth/getStoreListCollaborator']
        this.storeList.sort((a, b) => a.name.localeCompare(b.name))
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    checkIfFiltersSelected() {
      const temp = { status: false, need_action: false }
      this.deleteFiltersButton = JSON.stringify(this.filters) !== JSON.stringify(temp)
    },
    async removeFilters() {
      this.isClearingFilters = true

      this.needAction = false
      this.fileStatus = false
      this.fileWithRental = false
      this.selectedStore = null
      this.selectedStatusMacro = null
      this.selectedManufacturer = null
      this.selectedTransportModality = null
      this.selectedDates = null
      this.filters = { status: false, need_action: false }

      this.checkIfFiltersSelected()

      await this.$nextTick()

      this.isClearingFilters = false
    },
    async exportRepairFile() {
      this.loading = true
      try {
        await ExportService.repairFile(
          this.search,
          this.sort,
          this.order,
          this.page,
          this.limit,
          this.filters,
        )
        displayToast(this.$t('REPAIR_FILE_LIST_PAGE.EXPORT_REQUEST_SUCCESS'), 'success')
      } catch (error) {
        displayToast(this.$t('REPAIR_FILE_LIST_PAGE.EXPORT_REQUEST_FAILED'), 'error')
      } finally {
        this.loading = false
      }
    },
    async loadMoreRepairFile() {
      if (this.loadingMore || this.loading || this.page >= this.maxPage) {
        return
      }

      this.loadingMore = true
      this.page = this.page + 1

      try {
        const response = await RepairFileService.getPaginatedRepairFileFullList(
          this.search,
          this.sort,
          this.order,
          this.page,
          this.limit,
          this.filters
        )

        this.repairFileList = [...this.repairFileList, ...response.data]
        this.maxPage = response.max_page
      } catch (error) {
        handleResponseError(error)
        this.page = this.page - 1
      } finally {
        this.loadingMore = false
      }
    },
    setupInfiniteScroll() {
      this.$nextTick(() => {
        const trigger = this.$refs.infiniteScrollTrigger
        if (trigger) {
          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio > 0) {
                  this.loadMoreRepairFile()
                }
              })
            },
            {
              root: null,
              rootMargin: '100px',
              threshold: 0.1
            }
          )

          this.intersectionObserver.observe(trigger)
        }
      })
    },
    cleanupInfiniteScroll() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect()
        this.intersectionObserver = null
      }
    },
    onRowClick(_, rowEvent) {
      const item = rowEvent.item
      if (item.status_detail !== RepairFileStatusDetailConstant.DELETED) {
        router.push(`/repair-file-detail/${item.boomerang_id}`)
      }
    },
    sortBy(item) {
      this.page = 1
      if (item.length > 0) {
        this.isOrderNeutral = false
        this.sort = item[0].key
        this.order = item[0].order
      } else {
        this.isOrderNeutral = true
        this.order = 'desc'
      }
      this.getRepairFileFullList()
    },
    getInteractionUserColor(repairFile) {
      if (
        repairFile.status_detail === RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER ||
        repairFile.status_detail === RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER ||
        repairFile.status_detail === RepairFileStatusDetailConstant.RECEIPT_AT_STORE ||
        repairFile.status_detail === RepairFileStatusDetailConstant.SENT_AVAILABLE_TO_CUSTOMER
      ) {
        return 'text-orange'
      }
    },
    getDataTableFormattedValue(value) {
      return value ? value : this.$t('COMMON.NO_VALUE')
    },
    getStatusMacro(status_macro) {
      return this.$t('COMMON.STATUS_MACRO.' + status_macro)
    },
    setDayStyle(daysSinceCreation) {
      if (daysSinceCreation >= 20) {
        return 'red'
      } else if (daysSinceCreation >= 10) {
        return 'orange'
      } else {
        return 'green'
      }
    },
    getFormattedDate(date) {
      if (date) {
        return new Date(date).toLocaleDateString()
      } else {
        return this.$t('COMMON.NO_VALUE')
      }
    },
    getTransporterModality(modality) {
      if (modality in TransportModalityConstant) {
        return this.$t('REPAIR_FILE_LIST_PAGE.MODALITY.' + modality)
      } else {
        return this.$t('COMMON.NO_VALUE')
      }
    }
  }
}
</script>

<template>
  <v-row class="header">
    <v-col cols="12">
      <v-row class="d-flex align-center">
        <v-col cols="12" md="6">
          <v-text-field
            v-model.trim="search"
            v-model="search"
            :placeholder="$t('COMMON.FILTER.SEARCH')"
            hide-details
            density="compact"
            @keydown.enter="sendSearch()"
          >
            <template v-slot:append-inner>
              <v-btn @click="sendSearch()" variant="flat">
                {{ $t('COMMON.FILTER.SEARCH') }}
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex flex-row align-center ga-2">
          <v-btn
            @click="showFilter = !showFilter"
            variant="flat"
            rounded
          >
            <template #prepend>
              <img alt="filter" src="@/assets/icons/repair-file-list/filter.svg" />
            </template>
            <template #default>
              <span class="underline reset-btn">{{ $t('REPAIR_FILE_LIST_PAGE.FILTER') }}</span>
              <img
                alt="chevron down"
                class="ml-2"
                src="@/assets/icons/repair-file-list/chevron-down.svg"
              />
            </template>
          </v-btn>

          <v-btn
            v-if="deleteFiltersButton"
            @click="removeFilters()"
            variant="flat"
            rounded
          >
            <template #prepend>
              <img
                alt="close-cross-svg"
                src="@/assets/icons/repair-file-list/cross.svg"
              />
            </template>
            <template #default>
              <span class="underline">{{ $t('REPAIR_FILE_LIST_PAGE.DELETE_FILTER') }}</span>
            </template>
          </v-btn>

          <v-btn
            v-if="checkPermission(['DISTRIBUTOR_EXTRACT_REPAIR_FILE'])"
            @click="exportRepairFile()"
            variant="flat"
            rounded
          >
            <template #prepend>
              <img alt="export" src="@/assets/icons/repair-file-list/export.svg" />
            </template>
            <template #default>
              <span class="underline">{{ $t('REPAIR_FILE_LIST_PAGE.EXPORT') }}</span>
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" v-if="showFilter">
      <v-row>
        <v-col cols="12" md="3">
          <v-checkbox
            v-model="needAction"
            :label="$t('REPAIR_FILE_LIST_PAGE.FILTERS.USER_ACTION')"
            color="#559a1b"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-checkbox
            v-model="fileStatus"
            :label="$t('REPAIR_FILE_LIST_PAGE.FILTERS.CURRENT_FOLDER')"
            color="#559a1b"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-checkbox
            v-model="fileWithRental"
            :label="$t('REPAIR_FILE_LIST_PAGE.FILTERS.RENTAL')"
            color="#559a1b"
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="3">
          <v-date-input
            v-model="selectedDates"
            :label="$t('REPAIR_FILE_LIST_PAGE.FILTERS.DATE_CREATION')"
            :placeholder="$t('REPAIR_FILE_LIST_PAGE.FILTERS.DATE_CREATION')"
            clearable
            :max="today"
            hide-details
            multiple="range"
            @click:clear="selectedDates = null"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="3">
          <v-select
            id="select-manufacturer"
            v-model="selectedManufacturer"
            :items="manufacturerList"
            :no-data-text="$t('COMMON.NO_DATA')"
            :placeholder="$t('REPAIR_FILE_LIST_PAGE.PLACEHOLDER.MANUFACTURER')"
            hide-details
            item-title="name"
            item-value="boomerangId"
          >
            <template v-slot:selection="{ item }">
              <v-chip size="small">
                <span>{{ item.title }}</span>
              </v-chip>
            </template>
            <template v-slot:item="{ item, props }">
              <v-list-item :title="item.title" :value="item.value" v-bind="props">
                <v-tooltip
                  v-if="shouldShowTooltip(item, 'select-manufacturer')"
                  activator="parent"
                  location="bottom left"
                >
                  {{ item.title }}
                </v-tooltip>
              </v-list-item>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            id="select-status-macro"
            v-model="selectedStatusMacro"
            :items="statusMacroList"
            :no-data-text="$t('COMMON.NO_DATA')"
            :placeholder="$t('REPAIR_FILE_LIST_PAGE.PLACEHOLDER.STATUS_MACRO')"
            hide-details
            item-title="title"
            item-value="value"
          >
            <template v-slot:selection="{ item }">
              <v-chip size="small">
                <span>{{ item.title }}</span>
              </v-chip>
            </template>
            <template v-slot:item="{ item, props }">
              <v-list-item :title="item.title" :value="item.value" v-bind="props">
                <v-tooltip
                  v-if="shouldShowTooltip(item, 'select-status-macro')"
                  activator="parent"
                  location="bottom left"
                >
                  {{ item.title }}
                </v-tooltip>
              </v-list-item>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            id="select-store"
            v-model="selectedStore"
            :items="storeList"
            :no-data-text="$t('COMMON.NO_DATA')"
            :placeholder="$t('REPAIR_FILE_LIST_PAGE.PLACEHOLDER.STORE')"
            item-title="name"
            item-value="boomerang_id"
            hide-details
            multiple
          >
            <template v-slot:selection="{ item }">
              <v-chip size="small">
                <span>{{ item.title }}</span>
              </v-chip>
            </template>
            <template v-slot:item="{ item, props }">
              <v-list-item v-bind="props">
                <v-tooltip
                  v-if="shouldShowTooltip(item, 'select-store')"
                  activator="parent"
                  location="bottom left"
                >
                  {{ item.title }}
                </v-tooltip>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            id="select-modality"
            v-model="selectedTransportModality"
            :items="transportModalityList"
            :no-data-text="$t('COMMON.NO_DATA')"
            :placeholder="$t('REPAIR_FILE_LIST_PAGE.PLACEHOLDER.MODALITY')"
            item-title="title"
            item-value="value"
            hide-details
          >
            <template v-slot:selection="{ item }">
              <v-chip size="small">
                <span>{{ item.title }}</span>
              </v-chip>
            </template>
            <template v-slot:item="{ item, props }">
              <v-list-item v-bind="props">
                <v-tooltip
                  v-if="shouldShowTooltip(item, 'select-modality')"
                  activator="parent"
                  location="bottom left"
                >
                  {{ item.title }}
                </v-tooltip>
              </v-list-item>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

  <v-container fluid>
    <v-data-table
      ref="dataTable"
      :loading="loading"
      :headers="headers"
      :items="repairFileList"
      @click:row="onRowClick"
      :sort-asc-icon="ascSortIcon"
      :sort-desc-icon="descSortIcon"
      @update:sort-by="sortBy"
    >
      <template #loading>
        <div class="d-flex flex-column justify-center align-center pa-8">
          {{ $t('REPAIR_FILE_LIST_PAGE.TABLE.LOADING_REPAIR_FILES') }}
          <v-progress-linear class="my-5" color="#165039" indeterminate />
        </div>
      </template>

      <template #no-data>
        <div class="d-flex flex-column justify-center align-center pa-8">
          {{ $t('REPAIR_FILE_LIST_PAGE.TABLE.NO_REPAIR_FILE') }}
          <div class="d-flex align-center justify-center mt-8">
            <img src="@/assets/images/empty.svg" width="100" alt="Empty" />
          </div>
        </div>
      </template>

      <template #[`item.internal_command_number`]="{ item }">
        <span class="color-light" :class="getInteractionUserColor(item)">
          {{ item.internal_command_number }}
        </span>
      </template>

      <template #[`item.store_name`]="{ item }">
        <span class="color-light">
          {{ item.store_name }}
        </span>
      </template>

      <template #[`item.company`]="{ item }">
        <span class="font-weight-bold">
          {{ getDataTableFormattedValue(item.company) }}
        </span>
      </template>

      <template #[`item.manufacturer_name`]="{ item }">
        <span class="font-weight-bold">
          {{ item.manufacturer_name }}
        </span>
      </template>

      <template #[`item.product_name`]="{ item }">
        <span class="font-weight-bold">
          {{ item.product_name }}
        </span>
      </template>

      <template #[`item.has_rental_file`]="{ item }">
        <span class="color-light">
          {{ item.has_rental_file === true ? $t('COMMON.BUTTON.YES') : $t('COMMON.BUTTON.NO') }}
        </span>
      </template>

      <template #[`item.status_macro`]="{ item }">
        <span>{{ getStatusMacro(item.status_macro) }}</span>
      </template>

      <template #[`item.business_created_day_count`]="{ item }">
        <span :class="setDayStyle(item.business_created_day_count)">
          {{
            item.business_created_day_count >= 0
              ? item.business_created_day_count + ' ' + $t('REPAIR_FILE_LIST_PAGE.DAYS')
              : $t('COMMON.NO_VALUE')
          }}
        </span>
      </template>

      <template #[`item.business_created_at`]="{ item }">
        <span>
          {{ getFormattedDate(item.business_created_at) }}
        </span>
      </template>

      <template #[`item.transporter_modality`]="{ item }">
        <span>
          {{ getTransporterModality(item.transporter_modality) }}
        </span>
      </template>

      <template #bottom>
        <div
          v-if="repairFileList.length > 0 && page < maxPage"
          ref="infiniteScrollTrigger"
          class="d-flex justify-center align-center pa-4"
        >
          <v-progress-circular v-if="loadingMore" indeterminate color="#165039" size="24" />
          <span v-if="loadingMore" class="ml-3">
            {{ $t('REPAIR_FILE_LIST_PAGE.TABLE.LOADING_REPAIR_FILES') }}
          </span>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<style scoped>
.header {
  padding: 50px 40px;
  background-color: #ffffff;
}

.filter,
.export,
.delete-filter {
  cursor: pointer;
}

.underline {
  font-size: 14px;
  line-height: normal;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.v-container {
  padding: 32px;
}

.v-table {
  border-radius: 20px !important;
}

.color-light {
  color: #bfbfbf;
}

.red {
  background-color: var(--error-color);
}

.orange {
  background-color: var(--warning-color);
}

.green {
  background-color: #86c94e;
}

.text-orange {
  color: var(--warning-color);
}

.red,
.orange,
.green {
  color: white;
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 5px;
}

.custom-btn {
  box-shadow: none;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  min-width: fit-content;
}

.custom-btn:hover {
  box-shadow: none;
}
</style>
